// Centralized Sponsorship page content for different WCHSS years.

export const sponsorshipContent2026 = {
  categories: [
    {
      title: 'Principal Sponsor',
      price: 'IDR 150.000.000',
      benefits: [
        'Main logo placement on all conference materials',
        'Logo placement on website, backdrop, seminar kit, and publication media',
        'Recognition during opening and closing ceremony',
        'Complimentary conference registrations',
        'Exhibition booth opportunity',
        'Social media and promotional exposure',
        'Networking opportunity with speakers and participants',
      ],
    },
    {
      title: 'Supporting Sponsor',
      price: 'IDR 100.000.000',
      benefits: [
        'Logo placement on selected conference materials',
        'Recognition on conference website and social media',
        'Complimentary registrations',
        'Exhibition and branding opportunity',
        'Sponsor acknowledgement during conference sessions',
      ],
    },
    {
      title: 'Participating Sponsor',
      price: 'IDR 50.000.000',
      benefits: [
        'Logo placement on website and seminar materials',
        'Sponsor acknowledgement during conference',
        'Promotional opportunity during activities',
      ],
    },
  ],
};
